export default __webpack_public_path__ + "static/media/purple_bg.eaa64168.svg";